<template>
    <div>
        <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            :error.sync="error"
            error-text="请求失败，点击重新加载"
            :offset="10"
            @load="loadMore"
        >
            <div v-if="dataList.length>0">
                <van-cell
                        v-for="(item, index) in dataList"
                        :key="index"
                        size="large"
                        :title="item[0].title + '：' +item[0].info"
                        :label="item[3].title + '：' +item[3].info"
                        is-link
                        @click="routingTo('estateView', item)"
                />
            </div>
        </van-list>
    </div>
</template>

<script>
    import {Cell, CellGroup, List} from 'vant';
    import 'vant/lib/cell/style';
    import 'vant/lib/cell-group/style';
    import 'vant/lib/list/style';

    export default {
        name: 'estate',
        components: {
            vanCellGroup: CellGroup,
            vanCell: Cell,
            vanList: List,
        },
        mounted(){
            this.getData();
        },
        data(){
            return {
                //van-list
                loading: false,
                finished: false,
                dataList: [],
                startResult: 1,
                error: false
            }
        },
        created(){

        },
        methods: {
            loadMore(){
                this.startResult += 1;
                this.getData();
                console.log(this.startResult);
            },
            getData(){
                let self = this;
                self.$http.post('/miapp/A4001/mpaasgatewayunencrypted', {
                    buztype: 5081,
                    ybmapMessage: {
                        startResult: self.startResult,
                        endResult: 10
                    }
                }).then(res => {
                    self.$utils.loading(false);
                    self.loading = false;
                    res = typeof res === 'string' ? JSON.parse(res) : res;
                    if(res.recode === '000000' || res.message === 'success'){
                        self.dataList = self.dataList.concat(res.result);
                        self.finished = self.dataList.length >= res.totalnum;
                    } else {
                        self.startResult = 1;
                        self.finished = true;
                        self.$utils.alert(res.msg, function(){
                            self.$router.go(-1);
                        });
                    }
                }).catch(res => {
                    self.$utils.loading(false);
                    self.error = true;
                    console.log("error", res);
                });
            },
            routingTo(target, item){
                let self = this;
                self.$router.push({
                    path: '/' + target,
                    query: {
                        'openweb': 'paschybrid',
                        'estateinfo': JSON.stringify(item),
                        'showdetail': 'true'
                    }
                });
            }
        }
    }
</script>

<style>
    body {background:#e5e5e5;}
</style>
<style lang="stylus" scoped>
    .van-cell__title
        font-size .32rem
    .van-cell__label
        font-size .3rem
    .van-cell
        align-items center
    .van-cell:not(:last-child)::after
        left 0
    .van-cell__right-icon
        color #518ede
</style>